// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1CwMI","bigColWidth":"Table_bigColWidth__1bL99","biggerColWidth":"Table_biggerColWidth__2Vygb","row":"Table_row__3SpJW","col":"Table_col__3g51z"};